import "../css/Animation.css"

export default function Animation(data) {
return(
    <div className='container_animation'>
        <div className="animation" id='an1'>{data.first}</div>
        <div className="animation" id='an2'>{data.second}</div>
        <div className="animation" id='an3'>{data.third}</div>
        <div className="animation" id='an4'>{data.fourth}</div>
        <div className="animation" id='an5'>{data.fifth}</div>
        </div>
    )
}

/*

<Animation
first=""
second=""
third=""
fourth=""
fifth=""
></Animation>

 */